import BookIndex from "components/shared/book/list";
import { DatetimeRange } from "components/shared/form";
import SharedReactTable from "components/shared/reactTable";
import TruncatedString from "components/shared/truncatedString";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { queryParams } from "helpers/reqparams";
import React from "react";

class LogList extends BookIndex {
    get tableColumns() {
        return [
            {
                Header: "#",
                id: "row",
                accessor: (d) => d.index,
                Cell: ({ row }) => this.props.params.start + row.index + 1,
                width: 50,
                sortable: false,
                notExportable: true,
            },
            {
                Header: "Дата",
                accessor: "date",
                width: 140,
                filterable: false,
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss (Z)"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss (Z)"),
            },
            { Header: "Пользователь", accessor: "userName", filterable: true },
            { Header: "IP адрес", accessor: "ipAddress", filterable: true },
            { Header: "Статус", accessor: "statusCode", width: 70, filterable: true, filterType: "int" },
            { Header: "Метод запроса", accessor: "httpMethod", width: 70, filterable: true },
            { Header: "Url запроса", accessor: "requestUrl", filterable: true },
            {
                Header: "Тело запроса",
                accessor: "requestBody",
                filterable: true,
                Cell: ({ value }) => <TruncatedString text={value} />,
            },
            {
                Header: "Исключение",
                accessor: "exception",
                filterable: true,
                Cell: ({ value }) => <TruncatedString text={value} />,
            },
            {
                Header: "Тело ответа",
                accessor: "responseBody",
                filterable: true,
                Cell: ({ value }) => <TruncatedString text={value} />,
            },
        ];
    }

    renderActions = () => {
        return <DatetimeRange name="date" {...this.props} />;
    };

    renderListComponent = () => {
        const tableProps = {
            rowCname: "row--clickable",
            withoutRecalculatePages: true,
            onRowClick: (row) =>
                this.props.history.push(
                    paths.userLogsShow(`${row.original.traceId}${queryParams({ date: row.original.date })}`),
                ),
        };
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} isLazy tableProps={tableProps} />;
    };
}

export default tableContainer(LogList, "userlogs");
